import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zM7.707 6.293a1 1 0 00-1.414 1.414L10.586 12l-4.293 4.293a1 1 0 001.414 1.414L12 13.414l4.293 4.293a1 1 0 001.414-1.414L13.414 12l4.293-4.293a1 1 0 10-1.414-1.414L12 10.586z",
  fill: "#262626"
}), React.createElement("path", {
  d: "M0 0h24v24H0z"
}));

var SvgCloseRegular = function SvgCloseRegular(props) {
  return React.createElement("svg", props, _ref);
};

export default SvgCloseRegular;